// IndexedDB 封装，兼容 Realm API 部分常用方法
// 只实现 objects、create、deleteAll、objectForPrimaryKey、write、close
// 仅供 web 端使用

const DB_NAME = 'beemsg-webdb';
const DB_VERSION = 1;

let dbPromise: Promise<IDBDatabase> | null = null;

function getDB(): Promise<IDBDatabase> {
  if (!dbPromise) {
    dbPromise = new Promise((resolve, reject) => {
      const request = indexedDB.open(DB_NAME, DB_VERSION);
      request.onupgradeneeded = (event) => {
        const db = request.result;
        // 这里可以根据 schema 动态创建表
        // 这里只做简单演示
        if (!db.objectStoreNames.contains('ChatList')) db.createObjectStore('ChatList', { keyPath: 'tid' });
        if (!db.objectStoreNames.contains('VersionConfig')) db.createObjectStore('VersionConfig', { keyPath: 'version' });
        if (!db.objectStoreNames.contains('UserList')) db.createObjectStore('UserList', { keyPath: 'uid' });
        if (!db.objectStoreNames.contains('FriendList')) db.createObjectStore('FriendList', { keyPath: 'uid' });
        if (!db.objectStoreNames.contains('GroupChatList')) db.createObjectStore('GroupChatList', { keyPath: 'tid' });
        if (!db.objectStoreNames.contains('MemberAvatarList')) db.createObjectStore('MemberAvatarList', { keyPath: 'id' });
        if (!db.objectStoreNames.contains('GroupSendMsg')) db.createObjectStore('GroupSendMsg', { keyPath: 'tid' });
        if (!db.objectStoreNames.contains('Message')) db.createObjectStore('Message', { keyPath: 'mid' });
      };
      request.onsuccess = () => resolve(request.result);
      request.onerror = () => reject(request.error);
    });
  }
  return dbPromise;
}

export async function objects(storeName: string): Promise<any[]> {
  const db = await getDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const req = store.getAll();
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function create(storeName: string, data: any) {
  const db = await getDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const req = store.put(data);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

export async function deleteAll(storeName: string) {
  const db = await getDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readwrite');
    const store = tx.objectStore(storeName);
    const req = store.clear();
    req.onsuccess = () => resolve(true);
    req.onerror = () => reject(req.error);
  });
}

export async function objectForPrimaryKey(storeName: string, key: any): Promise<any | undefined> {
  const db = await getDB();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(storeName, 'readonly');
    const store = tx.objectStore(storeName);
    const req = store.get(key);
    req.onsuccess = () => {
      // 返回可变副本，兼容 currChat.isQuit = true
      if (req.result) {
        resolve({ ...req.result });
      } else {
        resolve(undefined);
      }
    };
    req.onerror = () => reject(req.error);
  });
}

export async function close() {
  // IndexedDB 无需手动关闭
  return;
}

export async function write(fn: () => Promise<void> | void) {
  // 兼容 Realm 的 write，直接执行
  await fn();
}
